export const STREET = 'Palisadenstraße 90';
export const ZIP = '10243';
export const CITY = 'Berlin';
export const PHONE = '0800 000 98 00';
export const PHONE_INTERNATIONAL_AREA_CODE = '+49';
